import { createTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createTenderCallable = getCallable(createTenderDefinition);
